// Toggle back to top display on scroll
const backToTop = document.querySelector('.back-to-top');
if (backToTop) {
    setTimeout(() => {
        const maxHeight = document.body.scrollHeight - window.innerHeight;
        window.addEventListener('scroll', () => {
            backToTop.classList.toggle('visible', window.scrollY >= maxHeight - 200);
        });
    }, 250);
}